export type GetRandom = <T>(input: Array<T>) => T

export const getRandom: GetRandom = input => input[Math.floor(Math.random() * input.length)]
